import { DataList13FData } from "./DataList13FProps";

export const getFilteredData = ({
  data,
  query,
  lang,
}: {
  data: DataList13FData[];
  query: string;
  lang: "en" | "zh";
}) => {
  if (!query || !data?.length) return data;
  const queryLower = query.toLowerCase();
  const nameKey = lang === "zh" ? "investorName" : "investorNameEn";

  return data
    .filter((item) =>
      [item.investorName, item.investorNameEn, item.representative]
        .map((str) => str?.toLowerCase())
        .some((str) => str?.includes(queryLower))
    )
    .sort((a, b) =>
      a[nameKey]?.toLowerCase().startsWith(queryLower)
        ? -1
        : b[nameKey]?.toLowerCase().startsWith(queryLower)
        ? 1
        : 0
    );
};
